import { Client } from '@/app/api/clients';
import { BrandSummary } from '@/app/api/brands';
import { AgencySummary } from '@/app/api/agencies';
import { FiltersQueryParams } from '@/app/core/services/http';

import { Nullable } from '@/app/shared/types';

export enum UserType {
  Admin = 'admin',
  Agency = 'agency',
  Client = 'client',
  Brand = 'brand',
  Council = 'council',
}

export enum UserStatus {
  Active = 'active',
  Invited = 'invited',
  Inactive = 'inactive',
}

export interface User {
  id: number;
  type: UserType;
  name: Nullable<string>;
  email: string;
  brands: BrandSummary[];
  status: UserStatus;
  client: Nullable<Client>;
  agency: Nullable<AgencySummary>;
}

export interface CreateUser {
  type: UserType;
  email: string;
  phone_code?: string;
  phone_number?: string;
  council_id?: number;
  agency_id?: number;
  client_id?: number;
  name?: string;
  brand_ids?: number[];
}

export interface UpdateUser {
  phone_code?: string;
  phone_number?: string;
  name?: string;
  brand_ids?: number[];
}

export interface UsersFiltersQueryParams extends FiltersQueryParams {
  agency_id?: number;
  agency_ids?: number[];
  brand_id?: number;
  brand_ids?: number[];
  client_id?: number;
  client_ids?: number[];
  status?: string;
  statuses?: 'active' | 'invited' | 'inactive';
  type?: string;
  types?: string[];
}
